import { useContext } from "react";

import type { DashboardConfig } from "@lib/dashboardConfig";

import { BrazeDashboardConfigContext } from "./BrazeDashboardConfigContext";

/**
 * @note there are a vanishingly small number of use cases for this hook - you should
 * really only use this for writing debug or developer tools
 */
export const useMutateBrazeDashboardConfig = <SubField extends keyof DashboardConfig>(
  field: SubField
): ((value: DashboardConfig[SubField]) => void) => {
  const [, setConfig] = useContext(BrazeDashboardConfigContext);

  return (value) => {
    setConfig(field, value);
  };
};
